module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_summary01-c89a6f6fa3a7f936b25f36a1f74a1e36.png";